<template>
    <v-layout  row wrap class="pt-2">
        <v-flex xs12>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card elevation="3">
                        <v-card-title class="grey lighten-4 pa-2">
                            <h2 class="secondary--text">
                                {{ $t('company.page.tab.cookies') }}
                            </h2>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click="onSave()" small>{{ $t('rms.button.save') }}</v-btn>
                        </v-card-title>

                        <!-- Cookie Description -->
                        <v-card-text>
                            <v-flex xs12>
                                <v-card elevation="2" class="mt-4">
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-tabs
                                                    background-color="transparent"
                                                    color="basil"
                                                    grow
                                                    v-model="descriptionWidgetLanguage"
                                                >
                                                    <v-tab v-for="language in enabledLanguages" :key="language.value">
                                                        {{ language.text }}
                                                    </v-tab>
                                                </v-tabs>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-title>
                                    <v-card-text class="mt-3">
                                        <v-tabs-items v-model="descriptionWidgetLanguage">
                                            <v-tab-item
                                                v-for="language in enabledLanguages"
                                                :key="language.text"
                                            >
                                            <v-card
                                                color="basil"
                                                flat
                                            >
                                                <v-card-text>
                                                    <v-flex xs12 class="px-2">
                                                        <TextEditor
                                                            v-model="cookieData.description[language.value]"
                                                            :title="`Cookie Description ${language.text}`"
                                                        />
                                                    </v-flex>
                                                </v-card-text>
                                            </v-card>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-card-text>
                        <!-- Cookie Description -->

                        <v-card-title style="justify-content:flex-end;">
                            <v-btn class="ml-2" small color="primary" @click="addNewSection">
                                + {{ $t('company.page.tab.cookies.add.section.label') }}
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-flex xs12 md12 lg12 >
                                <v-card elevation="2" class="mt-4" v-for="(cookie, index) in cookieData.cookie_sections" :key="index">
                                    <v-card-title class="grey lighten-4 pa-2">
                                        <h2 class="secondary--text">
                                            {{ $t('company.page.tab.cookies.section.label') }} {{ index+1 }}
                                        </h2>
                                        <template v-if="index>=1">
                                            <v-spacer></v-spacer>
                                            <v-btn color="error" small icon fab @click="removeSection(index)"><v-icon>mdi-delete</v-icon></v-btn>
                                        </template>
                                    </v-card-title>
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs6>
                                                <v-tabs
                                                    background-color="transparent"
                                                    color="basil"
                                                    grow
                                                    v-model="cookie.widgetLanguage"
                                                >
                                                    <v-tab v-for="language in enabledLanguages" :key="language.value">
                                                        {{ language.text }}
                                                    </v-tab>
                                                </v-tabs>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-title>
                                    <v-card-text class="mt-3">
                                        <v-tabs-items v-model="cookie.widgetLanguage">
                                            <v-tab-item
                                                v-for="language in enabledLanguages"
                                                :key="language.text"
                                            >
                                            <v-card
                                                color="basil"
                                                flat
                                            >
                                                <v-card-text>
                                                    <v-flex xs12 class="px-2">
                                                        <v-text-field
                                                            v-model="cookie.title[language.value]"
                                                            :id="'text-' + language.value"
                                                            :label="$t('company.page.tab.cookies.section.title.label',{lang:language.text})"
                                                            name="text"
                                                            counter="255"
                                                            color="primary"
                                                            prepend-icon="$vuetify.icons.rms_agreement"
                                                            type="text"
                                                            class="pr-3"
                                                        />
                                                    </v-flex>
                                                    <v-flex xs12 class="px-2">
                                                        <TextEditor
                                                            v-model="cookie.description[language.value]"
                                                            :title="$t('company.page.tab.cookies.section.description.label',{lang:language.text})"
                                                        />
                                                    </v-flex>
                                                </v-card-text>
                                            </v-card>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-card-text>
                                    <v-card-text>
                                        <v-flex xs12 class="px-3">
                                            <v-switch
                                                v-model="cookie.showSwitcher"
                                                :label="$t('company.page.tab.cookies.section.switcher.label')"
                                                color="primary"
                                                value="true" />
                                        </v-flex>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import i18n from "@/i18n";
import DEFINES from '@/defines';
import { mapState } from "vuex";
import TextEditor from "@/components/TextEditor";

export default {
    name :'CompanyCookies',
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
        enabledLanguages() {
            if (this.company) {
                return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : DEFINES.LOCALES; 
            }else{
                return DEFINES.LOCALES
            }
        },
    },
    components: {
        TextEditor
    },
    data(){
        return {
            descriptionWidgetLanguage: 0,
            cookieData: this.getCookieDefaultData()
        }
    },
    mounted(){
        if (this.company.cookie_data) {
            this.cookieData = this.company.cookie_data
        }
    },
    methods: {
        getCookieDefaultData(){
            return {
                description :{
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    fr : '',
                    it : '',
                    cs : '',
                    de : '' 
                },
                cookie_sections:[this.getCookieSectionDefaultData()]
            }
        },
        getCookieSectionDefaultData(){
            return {
                widgetLanguage: 0,
                title: {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    fr : '',
                    it : '',
                    cs : '',
                    de : '' 
                },
                description: {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    fr : '',
                    it : '',
                    cs : '',
                    de : '' 
                },
                showSwitcher: true,
            }
        },
        addNewSection(){
            this.cookieData.cookie_sections.push(this.getCookieSectionDefaultData());
        },
        removeSection(index){
            this.cookieData.cookie_sections.splice(index, 1);
        },
        onSave(){
            let data = {
                company_id: this.company.id,
                cookieData: this.cookieData
            } 

            this.$store.dispatch('company/updateCookie', data)
            .then((response) => {
                this.$store.dispatch("app/showMessage", {
                    message: i18n.t("message.success.updated"),
                    color: "success",
                });
                this.$emit('handleCompanySync')
            }).catch((error) => {
                console.error("Error updating company data:", error);
            });
        }
    }          
}
</script>

<style lang="scss" scoped>

</style>